"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const components_1 = require("components");
const config_1 = require("config");
const merchant_portal_reducer_1 = require("merchant-portal-reducer");
const utils_1 = require("utils");
const ReportDetailsContainer_1 = __importDefault(require("./ReportDetailsContainer"));
function SalesReportDetails({ salesReports }) {
    // State
    const reportRef = (0, react_1.useRef)(null);
    const [summaryDetail, setSummaryDetail] = (0, react_1.useState)([]);
    const [locationData, setLocationData] = (0, react_1.useState)([]);
    const [allSelected, setAllSelected] = (0, react_1.useState)(false);
    const { summary, locationSummaries, transactions } = salesReports;
    const summaryWithSummaryLabel = {
        ...summary,
        locationName: 'SUMMARY',
        locationNumber: undefined,
        checked: false,
    };
    (0, react_1.useEffect)(() => {
        if (locationSummaries) {
            const locationsSummary = locationSummaries.map((location) => ({
                ...location,
                checked: false,
            }));
            setLocationData([summaryWithSummaryLabel, ...locationsSummary]);
        }
    }, [locationSummaries]);
    const setSummaryDetailLocation = (data) => {
        const value = locationData.findIndex((val) => val.locationName === data.locationName);
        locationData[value] = {
            ...locationData[value],
            checked: data.checked,
        };
        setLocationData([...locationData]);
        const locationNamesArr = locationData.map((location) => location.checked && location.locationName);
        setSummaryDetail(transactions
            .filter((transaction) => locationNamesArr.includes(transaction.locationName))
            .sort(compareTransactionsAsc));
    };
    const getSummaryDetailData = () => {
        return summaryDetail.map((summary) => ({
            column01: (0, utils_1.formatLocation)(summary.locationName, summary.locationId),
            column02: (0, utils_1.formatISODateStringAsUSMonthDayYear)(summary.createdAt),
            column03: summary.name.firstName + ' ' + summary.name.lastName,
            column04: summary.alphaeonAccountNumber?.slice(-4),
            column05: summary.authCode,
            column06: summary.planName,
            column07: summary.planIdentifier,
            column08: summary.programProductType,
            column09: summary.transactionType.toUpperCase(),
            column10: (0, utils_1.formatCurrency)(summary.amount, 2),
            column11: summary.status.toUpperCase(),
            column12: (0, utils_1.formatEmailAddress)(summary.associate),
            column13: summary.referenceId ?? '',
        }));
    };
    const getLocationSummary = () => {
        return locationData.map((location) => ({
            column01: location.locationName,
            column02: location.totalRefunds,
            column03: location.totalSales,
        }));
    };
    const getCSVData = () => {
        const summaryDetailData = getSummaryDetailData();
        const locationSummary = getLocationSummary();
        return [
            ...locationSummary,
            ...new Array(5).fill(config_1.EMPTY_SALES_REPORT_SUMMARY),
            config_1.SALES_REPORT_DETAIL_HEADER,
            ...summaryDetailData,
        ];
    };
    const selectAllLocation = (selected) => {
        setAllSelected(selected);
        if (selected) {
            setSummaryDetail(transactions.sort(compareTransactionsAsc));
            setLocationData(locationData.map((row) => ({ ...row, checked: true })));
        }
        else {
            setSummaryDetail([]);
            setLocationData(locationData.map((row) => ({ ...row, checked: false })));
        }
    };
    return ((0, jsx_runtime_1.jsx)(ReportDetailsContainer_1.default, { csvHeaders: config_1.SALES_REPORT_SUMMARY_HEADERS, csvFilename: "SalesReport.csv", csvData: getCSVData(), reportRef: reportRef, children: (0, jsx_runtime_1.jsxs)("div", { id: "report-container", ref: reportRef, children: [(0, jsx_runtime_1.jsx)("div", { className: "report-detail__headers m-t-20", children: (0, jsx_runtime_1.jsx)(components_1.H2, { className: "report-detail--title", children: "Sales Results" }) }), (0, jsx_runtime_1.jsx)("div", { className: "report-detail__summary m-t-50", children: locationSummaries?.length > 0 ? ((0, jsx_runtime_1.jsxs)(lp_components_1.Table, { data: locationData, children: [(0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "checked", label: "Show Details", className: "show-details", component: ({ data }) => ((0, jsx_runtime_1.jsx)(components_1.ApplicationActionCell, { data: data, setData: setSummaryDetailLocation, selectAllLocation: selectAllLocation, allSelected: allSelected })) }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "locationName", label: "Location" }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "totalRefunds", label: "Total Refunds", component: ({ data }) => {
                                    return (0, jsx_runtime_1.jsx)("td", { children: (0, utils_1.formatCurrency)(data.totalRefunds, 2) });
                                } }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "totalSales", label: "Total Sales", component: ({ data }) => {
                                    return (0, jsx_runtime_1.jsx)("td", { children: (0, utils_1.formatCurrency)(data.totalSales, 2) });
                                } })] })) : ((0, jsx_runtime_1.jsx)(components_1.P, { variant: "body-large", children: "No matching results" })) }), (0, jsx_runtime_1.jsx)("div", { className: "m-t-50 flex-space-between", children: (0, jsx_runtime_1.jsx)(components_1.H3, { variant: "headline-small", children: "Details" }) }), (0, jsx_runtime_1.jsx)("div", { id: "report-detail-table-div", className: "report-detail__summary-detail sales-report m-t-50", children: summaryDetail.length > 0 ? ((0, jsx_runtime_1.jsxs)(lp_components_1.Table, { id: "sales-report-table", className: "detail-table", data: summaryDetail, children: [(0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "location", label: "Location", valueGetter: ({ locationName, locationId, }) => (0, utils_1.formatLocation)(locationName, locationId) }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "createdAt", label: "Tran Date", format: (createdAt) => (0, utils_1.formatISODateStringAsUSMonthDayYear)(createdAt) }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "name", label: "Customer", component: ({ value }) => ((0, jsx_runtime_1.jsx)("td", { children: `${value.firstName} ${value.middleInitial ? value.middleInitial : ''} ${value.lastName}` })) }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "alphaeonAccountNumber", headerComponent: () => ((0, jsx_runtime_1.jsxs)("th", { children: ["Account/", (0, jsx_runtime_1.jsx)("br", {}), "Loan #", (0, jsx_runtime_1.jsx)("br", {}), "(Last 4)"] })), format: (value) => {
                                    const displayValue = value?.slice(-4);
                                    return value ? ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: `${config_1.ACCOUNT_DETAIL_URL}${value}`, children: displayValue })) : ('-');
                                } }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "authCode", label: "Auth #", style: { textAlign: 'center ' } }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "planName", label: "Plan" }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "planIdentifier", label: "Plan #" }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "productType", label: "Product Type", valueGetter: ({ programProductType, }) => {
                                    return String(programProductType ?? '-')
                                        .toUpperCase()
                                        .replace('_', ' ');
                                } }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "transactionType", label: "Tran Type", format: utils_1.formatUpperCase }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "amount", label: "Tran $", format: (amount) => (0, utils_1.formatCurrency)(amount, 2) }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "status", label: "Status", format: utils_1.formatUpperCase }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "associate", label: "Associate" }), (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "referenceId", label: "ReferenceID" })] })) : ((0, jsx_runtime_1.jsx)(components_1.P, { variant: "body-large", children: "Select Summary above to show Details" })) })] }) }));
}
function mapStateToProps(state) {
    return {
        salesReports: merchant_portal_reducer_1.selectors.salesReports(state),
    };
}
const mapDispatchToProps = {};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(SalesReportDetails);
function compareTransactionsAsc(t1, t2) {
    const locationId1 = t1.locationId;
    const locationId2 = t2.locationId;
    const transactionDate1 = t1.createdAt;
    const transactionDate2 = t2.createdAt;
    return ((0, utils_1.parseAndCompareDatesAsc)(transactionDate1, transactionDate2) ||
        locationId1 - locationId2);
}
